import { QueryObserverOptions, useQuery } from 'react-query';

import { useDlVaultContract } from 'clients/contracts/hooks';
import FunctionKey from 'constants/functionKey';

import getNetworkRewardRules, { GetNetworkRewardRulesInput, GetNetworkRewardRulesOutput } from '.';

type TrimmedGetNetworkRewardRulesInput = Omit<GetNetworkRewardRulesInput, 'dlVaultContract'>;

export type UseGetNetworkRewardRulesQueryKey = [
  FunctionKey.GET_NETWORK_REWARD_RULES,
  TrimmedGetNetworkRewardRulesInput,
];

type Options = QueryObserverOptions<
  GetNetworkRewardRulesOutput,
  Error,
  GetNetworkRewardRulesOutput,
  GetNetworkRewardRulesOutput,
  UseGetNetworkRewardRulesQueryKey
>;

const useGetNetworkRewardRules = (input: TrimmedGetNetworkRewardRulesInput, options?: Options) => {
  const dlVaultContract = useDlVaultContract();

  return useQuery(
    [FunctionKey.GET_NETWORK_REWARD_RULES, input],
    () => getNetworkRewardRules({ dlVaultContract, ...input }),
    options,
  );
};

export default useGetNetworkRewardRules; 